import { observer } from 'mobx-react-lite';
import styled from '@emotion/styled';
import { IContentSearchResult } from '../../../domain/types/IContentSearchResult';
import { SearchResultItem } from './SearchResultItem';
import { Css, UnstyledLi, UnstyledUl } from '../../../../../ui';

interface IProps {
	results: IContentSearchResult[];
}

export const List = observer(({ results }: IProps) => (
	<StyledList>
		{results.map((result) => (
			<StyledListItem key={result.id} className="no-max-width">
				<SearchResultItem result={result} />
			</StyledListItem>
		))}
	</StyledList>
));

const StyledList = styled(UnstyledUl)`
	display: flex;
	flex-direction: column;
	gap: ${Css.pxToRem(8)};

	margin-bottom: ${Css.pxToRem(16)};
`;

const StyledListItem = styled(UnstyledLi)`
	width: 100%;
`;
